import { useDeviceType } from '@cian/ui-kit';
import * as style from './Title.css';
import clsx from 'clsx';

interface ITitleProps {
  children: string;
}

export const Title: React.FC<ITitleProps> = ({ children }) => {
  const device = useDeviceType();

  return (
    <div
      className={clsx(
        style['title'],
        device === 'tablet' && style['title-tablet'],
        device === 'phone' && style['title-phone'],
      )}
    >
      {children}
    </div>
  );
};
